<template>
	<div id="window_portal" v-if="open">
		<slot :window="windowRef" />
	</div>
</template>

<script>

export default {
	name: 'window-portal',
	model: {
		prop: 'open',
		event: 'close'
	},

	props: {
		open: { type: Boolean, default: false, },
		title: { type: String, default: "" },
	},

	data() {
		return {
			windowRef : null,
			tooltip_name : "window-tooltip",
			tooltip_listeners : []
		}
	},

	mounted() {
		if (this.open) {
			this.openPortal()
		}
	},

	beforeDestroy() {
		if (this.windowRef) {
			this.closePortal()
		}
	},

	watch: {
		open(newOpen) {
			if (newOpen) {
				this.openPortal()
			} else {
				this.closePortal()
			}
		},
		title(newTitle) {
			if (this.windowRef) this.windowRef.document.title = newTitle
		}
	},

	methods: {
		openPortal() {
			this.windowRef = window.open("", "", "width=600,height=400,left=200,top=200")
			this.windowRef.document.title = this.title
			this.windowRef.document.body.appendChild(this.$el)

			if (!this.noStyle) {
				for (const el of document.head.querySelectorAll('style, link[rel=stylesheet]')) {
					const clone = el.cloneNode(true)
					this.windowRef.document.head.appendChild(clone)
				}
			}

			this.tooltip = this.windowRef.document.createElement('div')
			this.tooltip.style.position = 'absolute'
			this.tooltip.classList.add(this.tooltip_name)
			this.windowRef.document.body.appendChild(this.tooltip)

			this.attach(this.windowRef.document.body)

			this.windowRef.addEventListener('beforeunload', this.closePortal)
		},

		closePortal() {
			if (this.windowRef) {
				this.windowRef.close()
				this.windowRef = null
				this.$emit('close')
			}
		},

		attach(root) {
			this
				.delegate('mouseover', root, '[data-tooltip]', this.onShow)
				.delegate('mouseout', root, '[data-tooltip]', this.onHide)

		},

		delegate(eventName, element, cssSelector, callback) {
			const fn = (event) => {
				const el = event.target
				if (!el.matches(cssSelector)) {
					return;
				}

				callback(event)
			}

			element.addEventListener(eventName, fn)
			this.tooltip_listeners.push({ fn, element, eventName })

			return this
		},

		onShow(event)
		{
			const indent = 0
			
			const sourceEl = event.target
			const element = sourceEl.getAttribute('data-tooltip')

			if (element)
			{
				this.tooltip.textContent = element
			}
			
			this.tooltip.classList.add(`${this.tooltip_name}_active`)

			const sourceElRect = sourceEl.getBoundingClientRect()

			let top = sourceElRect.bottom + indent
			const left = sourceElRect.left

			this.tooltip.style.top = `${top + window.scrollY}px`
			this.tooltip.style.left = `${left + window.scrollX}px`
		},

		onHide()
		{
			this.tooltip.classList.remove(`${this.tooltip_name}_active`)
			this.tooltip.textContent = ""
		}
	}
}
</script>

<style scoped>
@font-face {
	font-family: "Inter_window";
	src: url('~@/assets/fonts/Inter-Regular.eot');
	src: url('~@/assets/fonts/Inter-Regular.eot?#iefix') format('embedded-opentype'),
		url('~@/assets/fonts/Inter-Regular.woff2') format('woff2'),
		url('~@/assets/fonts/Inter-Regular.woff') format('woff'),
		url('~@/assets/fonts/Inter-Regular.ttf') format('truetype'),
		url('~@/assets/fonts/Inter-Regular.svg#Inter-Regular') format('svg');
	font-weight: normal;
	font-style: normal;
	font-display: swap;
}

#window_portal
{
	font-family: "Inter_window";
}
</style>

<style>
#window_portal .vs__fade-enter
{
	opacity: 1;
}

#window_portal .vs__fade-enter-active
{
	pointer-events: auto;
}

.window-tooltip
{
	display: none;

	box-shadow: 0 10px 15px 0 var(--bft-neutral-500-tooltip) !important;
	border-radius: 0.25rem;
	background-color: var(--bft-neutral-900-tooltip);
	/* opacity: 0;
	transition: opacity .15s linear; */

	padding: 0.25rem 0.5rem;
	color: white;
	font-size: 0.875rem;
	z-index: 1000;
}

.window-tooltip.window-tooltip_active {
    display: block;
    position: absolute;
	/* opacity: 1; */
}
</style>